import React, { useState } from "react"
import * as AppConstants from "../../../utility/AppConstants"
import * as Utility from "../../../utility/Utility"
import InfoRiservatezza from "../../avvisi/InfoRiservatezza"
import TabTitle from "./include/TabTitle"
import 'Css/table.css'
// modal;
import ModalMob from "../../modal/ModalMob"
import { Table, Messages } from "@sogei/react-web-components-catalog"
function TabMacroareeTerritoriali(props: any) {
    let macroareeTerritoriali = props.macroareeTerritoriali

    const apriDescrizione = (mobSelezionato: any[]) => setMob(mobSelezionato)
    const [mob, setMob] = useState<any[]>([])

    return (
        <div id="tab-macroaree-territoriali">
            <TabTitle
                title={AppConstants.TITLE_MACROAREE_TERRITORIALI}
                {...props}
            />

            <div className="row">
                <div className="col-12 ">
                    <Table
                        tableHead={
                            <tr>
                                <th>
                                    {Utility.getValoreHeader(
                                        props.codIsa,
                                        props.macroarea
                                    )}
                                </th>
                                <th className="th-statistiche">
                                    {AppConstants.MACROAREE_TERRITORIALI_NORD_OVEST.toUpperCase()}
                                </th>
                                <th className="th-statistiche">
                                    {AppConstants.MACROAREE_TERRITORIALI_NORD_EST.toUpperCase()}
                                </th>
                                <th className="th-statistiche">
                                    {AppConstants.MACROAREE_TERRITORIALI_CENTRO.toUpperCase()}
                                </th>
                                <th className="th-statistiche">
                                    {AppConstants.MACROAREE_TERRITORIALI_SUD.toUpperCase()}
                                </th>
                                <th className="th-statistiche">
                                    {AppConstants.MACROAREE_TERRITORIALI_ISOLE.toUpperCase()}
                                </th>
                            </tr>
                        }
                        tableBody={
                            macroareeTerritoriali !== null &&
                            macroareeTerritoriali !== undefined ? (
                                macroareeTerritoriali.listaMob.map(
                                    (mobElem: any, key: number) => (
                                        <tr className="tableStatIsa" key={key}>
                                            <th>
                                                {mobElem.nome}
                                                <span
                                                    className="far fa-question-circle fa-1x modal-mob"
                                                    style={{
                                                        cursor: "pointer"
                                                    }}
                                                    data-toggle="modal"
                                                    data-target="#modal-1"
                                                    onClick={() =>
                                                        apriDescrizione(mobElem)
                                                    }
                                                />
                                            </th>

                                            <td>
                                                {Utility.valoreMobArea(
                                                    macroareeTerritoriali,
                                                    mobElem.nome,
                                                    0
                                                )}
                                            </td>
                                            <td>
                                                {Utility.valoreMobArea(
                                                    macroareeTerritoriali,
                                                    mobElem.nome,
                                                    1
                                                )}
                                            </td>
                                            <td>
                                                {Utility.valoreMobArea(
                                                    macroareeTerritoriali,
                                                    mobElem.nome,
                                                    2
                                                )}
                                            </td>
                                            <td>
                                                {Utility.valoreMobArea(
                                                    macroareeTerritoriali,
                                                    mobElem.nome,
                                                    3
                                                )}
                                            </td>
                                            <td>
                                                {Utility.valoreMobArea(
                                                    macroareeTerritoriali,
                                                    mobElem.nome,
                                                    4
                                                )}
                                            </td>
                                        </tr>
                                    )
                                )
                            ) : (
                                <React.Fragment />
                            )
                        }
                        tableOptions={["table-hover"]}
                    >
                        <caption className="sr-only">
                            {AppConstants.TITLE_MACROAREE_TERRITORIALI} -{" "}
                            {Utility.getValoreHeader(
                                props.codIsa,
                                props.macroarea
                            )}
                        </caption>
                    </Table>
                   
                </div>
            </div>

            {<ModalMob mob={mob} />}
            <InfoRiservatezza />
            <Messages
                successMessages={[]}
                infoMessages={[
                    {
                        text: `Sono escluse le posizioni ISA per le quali non è stato dichiarato il comune`
                    }
                ]}
                warningMessages={[]}
                dangerMessages={[]}
            ></Messages>
        </div>
    )
}

export default TabMacroareeTerritoriali
